import { Skeleton } from "@chakra-ui/react";
import React from "react";
import { GenericError } from "src/components/Feedback/GenericError";
import { MultiSelectInput } from "src/components/Inputs/MultiSelectInput";
import { RemoteDataView } from "src/components/Layout/RemoteDataView";
import { HighlightedText } from "src/components/Text/HighlightedText";
import { GetGradeConfigByEnrollmentPeriodResponse } from "src/generated/hooks/form-service/requests";
import * as RD from "src/types/remoteData";

export type Grade = {
  id: string;
  label: string;
};
type Props = {
  remoteData: RD.RemoteData<unknown, GetGradeConfigByEnrollmentPeriodResponse>;
  onChange: (grades: Grade[] | null) => void;
  selectedGrades: Grade[];
};
export const GradesMultiSelectInput: React.FC<Props> = ({
  remoteData,
  onChange,
  selectedGrades,
}) => {
  return (
    <RemoteDataView
      error={() => <GenericError variant="inline" />}
      remoteData={remoteData}
      loading={<Skeleton height="1rem" width="200px" />}
    >
      {(grades) => (
        <MultiSelectInput
          variant="check"
          leftIcon={null}
          selectAllItem={{ enable: true, text: "All grades" }}
          options={grades.data}
          placeholder="Select grades"
          labelAttr="label"
          label={undefined}
          onChange={(newGrades: Grade[]) => {
            if (newGrades.length === grades.data.length) {
              // all grades
              onChange(null);
            } else {
              onChange(newGrades);
            }
          }}
          selectedItems={selectedGrades}
          size="md"
          renderDropdownItem={(option, keyword) => (
            <HighlightedText text={option.label} keyword={keyword} invert />
          )}
        />
      )}
    </RemoteDataView>
  );
};
